/**
 * 获取某个商品的standard 数据
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const goodsStandards = (state) => {
    const arr = [].slice.call(state.standards.list, 0)
    return arr.filter( (item, index) => {
        return ([].indexOf.call([1,2,3], item.id) != -1)
    })
}

/**
 * 获取某个分类下的农友伙伴数据
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const classifyFarmers = (state) => {
    const arr = [].slice.call(state.farmer.list, 0)
    return arr.filter( (item, index) => {
        return ([].indexOf.call(state.category.farmerIds, item.id) != -1)
    })
}

/**
 * 获取当前编辑的地址详情
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */
export const getAddressDetail = (state) => {
    const arr = [].slice.call(state.member.addressList, 0)
    let result =  []

    if (arr.length > 0) {
        result = arr.filter( (item, index) => {
            return item.id == state.member.curAddressId
        })
    }

    return (result.length > 0) ? result[0] : {}
}

/**
 * 获取用户地址列表
 */
export const getAddressList = (state) => {
    let arr = ['北京', '重庆', '上海', '天津']
    let list = ['内蒙古', '广西', '西藏', '新疆', '宁夏']
    let result = [].slice.call(state.member.addressList, 0)

    result.forEach((item) => {
        if (arr.indexOf(item.full_district[0]) != -1) {
            item.desc = `${item.full_district[0]}直辖市${item.full_district[2]}区`
        } else if (list.indexOf(item.full_district[0]) != -1) {
            item.desc = `${item.full_district[0]}自治区${item.full_district[1]}市${item.full_district[2]}区`
        } else {
            item.desc = `${item.full_district[0]}省${item.full_district[1]}市${item.full_district[2]}区`
        }
    })
    return result
}

/**
 * 获取用户默认地址id
 */
export const getDefaultAddressId = (state) => {
    let arr = []

    if (state.member.addressList.length > 0) {
        arr = state.member.addressList.filter((item) => {
            return item.isdefault == 1
        })
    }
    return (arr.length > 0) ? arr[0]['id'] : 0
}

/** 获取套餐挑选页选中商品总金额 **/
export const getCheckedAmount = (state) => {
    let money = 0,
        unit_money = 0

    if (state.packages.carts.length > 0) {
        state.packages.carts.forEach((item) => {
            unit_money = parseInt(item.unit_price * 100)

            money += parseInt(item.num) * unit_money
        })
    }

    return (money / 100)
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js